import React from 'react'
import { useAssignmentStore } from '../../store/assignment.store'
import { Box, DialogActions, Button, Dialog, DialogContent, Typography, Collapse, Chip, useTheme, } from '@mui/material'
import uploadAssignmentImg from '../../assets/upload-assignment.svg'
import { chipColors } from '../../utils/utilities'
import RemoveCircle from '@mui/icons-material/RemoveCircle'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'

const SubmitAssignmentDialog = ( { onClose, selectedValue, open } ) => {
    const RoomStore = useAssignmentStore()

    const [dropping, setDropping] = React.useState( false )
    const [attachments, setAttachments] = React.useState( [] )
    const [uploading, setUploading] = React.useState( false )

    const { palette, border } = useTheme()

    const handleClose = () => {
        onClose( selectedValue )
    }

    const handleFilesInput = ( e ) => {
        let files = []
        let wrongFormats = []
        for ( let i = 0; i < e.target.files.length; i++ ) {
            const file = e.target.files[i]
            if ( ["docx", "pdf"].includes( file.name?.split( "." )?.pop()?.toLowerCase() ) && file.size < 50 * 1024 * 1024 )
                files.push( file )
            else
                wrongFormats.push( file.name )
        }
        setAttachments( [...attachments, ...files] )
        if ( wrongFormats.length > 0 )
            toast( `Unsupported or large file found: ${wrongFormats.join( ", " )}` )
        e.target.value = ""
    }

    const removeFile = ( index ) => {
        const updatedFiles = [...attachments]
        updatedFiles.splice( index, 1 )
        setAttachments( updatedFiles )
    }

    const submitAssignment = async () => {
        //e.preventDefault();
        setUploading( true )
        if ( attachments.length === 0 ) {
            toast.error( "Please select files you want to submit!" )
            setUploading( false )
            return
        }
        const formData = new FormData()
        for ( let i = 0; i < attachments.length; i++ ) {
            console.log( attachments )
            formData.append( "attachments", attachments[i] )
        }
        formData.append( "assignment_id", selectedValue['assignment_id'] )

        await RoomStore.uploadAssignmentSubmission( formData )
        setUploading( false )
        handleClose()
        setAttachments( [] )
    }
    return (
        <Dialog fullWidth={true} maxWidth={'sm'} onClose={handleClose} aria-labelledby="submit-dialog-title" open={open}>
            <Box padding="20px 20px 10px 20px">
                <Typography variant='h6'>{selectedValue.assignment_name}</Typography>
                <Typography variant='subtitle2' caolor="textSecondary">Submit you answers here.</Typography>
            </Box>
            <DialogContent>
                <form>
                    <Box sx={{ position: "relative", border: "2px dashed rgba(0,0,0,0.3)", padding: "20px" }} >
                        <input onDragLeave={() => setDropping( false )} onDrop={() => setDropping( false )} onDragEnter={() => setDropping( true )} accept='.pdf, .docx, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document' type="file" disabled={uploading} style={{ position: "absolute", opacity: 0, top: 0, left: 0, right: 0, bottom: 0, cursor: "pointer" }} onChange={handleFilesInput} multiple />
                        <Box flexGrow={1} display="flex" gap="10px" flexDirection="column" alignItems="center">
                            <img src={uploadAssignmentImg} alt="Upload assignment" width="120px" />
                            {!dropping && <Box display="flex" gap="5px" flexDirection="column" alignItems="center">
                                <Typography textAlign="center" variant="body1" fontWeight="600" >Upload assignment</Typography>
                                <Typography textAlign="center" variant="subtitle2" color="textSecondary">Drag and drop files here or  <span style={{ color: palette.secondary.main }}>Browse</span> </Typography>
                                <Typography textAlign="center" variant="body2" >Accepted formats: <strong><em><span style={{ color: palette.secondary.main }}>.PDF and .DOCX</span></em></strong> </Typography>
                                <Typography textAlign="center" variant="subtitle2" color="textSecondary" fontSize="12px">Max Size: 50MB</Typography>
                            </Box>}
                            {dropping && <Box flexGrow={1} display="flex" gap="5px" flexDirection="column" justifyContent="center" alignItems="center">
                                <Typography sx={{ pointerEvents: "none" }} className='animation-shake' variant="h6" color="grey">Drop the assignment files here!</Typography>
                            </Box>}
                        </Box>
                    </Box>
                    <Collapse in={attachments.length > 0}>
                        <Box display="flex" gap="5px" flexWrap="wrap" marginTop="20px">
                            {attachments.map( ( item, index ) => (
                                <Chip sx={{ color: "white", background: chipColors[index % chipColors.length] }} deleteIcon={<RemoveCircle sx={{ color: "white !important" }} />} key={item.name} onDelete={() => removeFile( index )} label={item.name} />
                            ) )}
                        </Box>
                    </Collapse>
                </form>
            </DialogContent>
            <DialogActions>
                <Button disabled={uploading} onClick={handleClose} color="error">
                    Close
                </Button>
                <Button disabled={uploading} onClick={submitAssignment} color="primary">
                    {!uploading ? 'Upload' : "Uploading..."}
                </Button>
            </DialogActions>
        </Dialog >
    )
}

SubmitAssignmentDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.object.isRequired
}

export default SubmitAssignmentDialog
